<template>
  <v-card>
    <vue-title :title="data.application.title" />
    <v-card-text class="v-card__text">
        <v-form v-model="valid">
          <h3 class="headline mb-0">{{data.application.title}} <v-btn :to="'/app/applications/'+data.application.id" icon flat small><v-icon>arrow_right_alt</v-icon></v-btn></h3>
          {{$t('races.title')}}: <router-link :to="'/app/races/'+data.raceId">{{data.race.name}}</router-link><br />
          {{$t('runs.startNumber')}}: {{data.startNumber}}
            <v-text-field v-model="data.time" :label="$t('runs.time')"/>
            <v-checkbox v-model="data.disqualification" :label="$t('runs.disqualification')" />
            <v-textarea
                    name="input-7-1"
                    :label="$t('application.remarks')"
                    v-model="data.remarks"
                    ></v-textarea>
        </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save()" color="success">{{$t('ctrl.save')}}</v-btn>
      
    </v-card-actions>
    <v-snackbar
      v-model="snackbar"
      :bottom="true"
      :timeout="5000">
      {{ $t('ctrl.successfullySaved') }}
      <v-btn
        color="red"
        @click="snackbar = false">
        {{ $t('ctrl.close') }}
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
    VTextarea,
    VSnackbar,
    VCheckbox
  } from 'vuetify/lib'
  import fccapi from '../../fccapi.js'

  export default {
    name: 'FCCRunDetails',
    props: {
      data: Object,
      races: []
    },
    data: () => ({
      snackbar: false
    }),
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      }
    },
    methods: {
      save: function(){
        fccapi.post(`runs/${this.$route.params.id}`, {Remarks: this.data.remarks, Time: this.data.time, Disqualification: this.data.disqualification}).then(d => {
          this.snackbar = true;
        })
      }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        VTextarea,
        VSnackbar,
        VCheckbox
    },
    mounted: function(){
      fccapi.get(`runs/${this.$route.params.id}`).then(d => {
        this.data = d.data
      }).catch(e => {
        console.log(e)
      })
    }
  }
</script>